import React from "react";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserRound, Clock, BarChart } from "lucide-react";
import { StairsIcon } from "@/components/icons/StairsIcon";
import { useTranslation } from "react-i18next";
import footstepsIcon from "/footsteps.svg";

interface TutorialAuthorProps {
  author: string;
  date: string;
  steps: number;
  duration: string;
  complexity: string;
  avatarUrl?: string;
}

export const TutorialAuthor = ({ author, date, steps, duration, complexity, avatarUrl }: TutorialAuthorProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between border-b pb-4">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between w-full gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-secondary/20 flex items-center justify-center">
            <UserRound className="w-5 h-5 text-muted-foreground" />
          </div>
          <div className="flex flex-col">
            <span className="text-lg font-semibold text-foreground">{author}</span>
            <span className="text-sm text-muted-foreground">{t('tutorial.author.role')}</span>
          </div>

          {/*<Button
            variant="outline"
            size="sm"
            className="bg-card hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
          >
            Follow
          </Button>*/}
        </div>

        <div className="flex items-center gap-4 md:ml-auto">
          <div className="flex items-center gap-1.5">
            <div className="w-7 h-7 rounded-full bg-secondary/20 flex items-center justify-center">
              <img
                src={footstepsIcon}
                alt="steps"
                className="w-3.5 h-3.5 text-muted-foreground"
                style={{ filter: 'var(--svg-filter-muted-foreground)' }}
              />
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">{t('tutorial.author.steps')}</span>
              <span className="text-sm font-semibold">{steps}</span>
            </div>
          </div>

          <div className="flex items-center gap-1.5">
            <div className="w-7 h-7 rounded-full bg-secondary/20 flex items-center justify-center">
              <Clock className="w-3.5 h-3.5 text-muted-foreground" />
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">{t('tutorial.author.duration')}</span>
              <span className="text-sm font-semibold">{duration || "-"}</span>
            </div>
          </div>

          <div className="flex items-center gap-1.5">
            <div className="w-7 h-7 rounded-full bg-secondary/20 flex items-center justify-center">
              <BarChart className="w-3.5 h-3.5 text-muted-foreground" />
            </div>
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">{t('tutorial.author.complexity')}</span>
              <span className="text-sm font-semibold">{complexity || "-"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
